/*
 Script apertura iframe embed dopo load pagina
 */
function initVideo() {
    setTimeout(function (){
        var vidDefer = document.getElementsByTagName('iframe');
        for (var i=0; i<vidDefer.length; i++) {
            if(vidDefer[i].getAttribute('data-src')) {
                vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
            }
        }
    },1000);
}
window.onload = initVideo;
